import React from 'react';
import './Footer.css'

function Footer() {
    return (
        <div className='footer'>
            <p>© 2020 Armazon | Free Market Rights - E-Commerce Shop App by <a href="http://github.com/arefathi" > Arefat Hyeredin</a> </p>
            <p>About · Business · Orders · Help · Terms · Sitemap · Contact  </p>
        </div>
    )
}

export default Footer
